import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/messaging-centre/components/MessagingCentreScreen.tsx");
